import { ButtonSize, ToggleButton, Tooltip, TooltipTrigger } from '@vizit/atoms';
import { useShowFavorites } from '@vizit/feature-flags';
import { HeartIcon } from '@vizit/icons';

interface CollectionAssetToolbarFavoritesToggleProps {
  /**
   * When true, only favorited assets are shown
   */
  favoritesOnly: boolean;
  /**
   * Called when the user toggles the favorites-only filter
   */
  onFavoritesOnlyChange: (favoritesOnly: boolean) => void;
}

/**
 * Favorites-only toggle for `CollectionAssetToolbar.Filters`. Renders nothing while favorites are
 * not enabled for the workspace.
 *
 * @param props - The component props
 */
function CollectionAssetToolbarFavoritesToggle(props: CollectionAssetToolbarFavoritesToggleProps) {
  const { favoritesOnly, onFavoritesOnlyChange } = props;
  const showFavorites = useShowFavorites();

  if (!showFavorites) {
    return null;
  }

  return (
    <TooltipTrigger delay={300}>
      <ToggleButton
        aria-label="Show favorites only"
        isSelected={favoritesOnly}
        onChange={onFavoritesOnlyChange}
        size={ButtonSize.Md}
        iconStart={<HeartIcon size={20} aria-hidden />}
        data-testid="collection-asset-favorites-toggle"
      />
      <Tooltip>Show favorites only</Tooltip>
    </TooltipTrigger>
  );
}

export { CollectionAssetToolbarFavoritesToggle };
export type { CollectionAssetToolbarFavoritesToggleProps };
